<template>
  <layout-auth>
    <v-form
      v-model="formulario"
      @submit.prevent="post_company_data"
      ref="formuarioCompanyData"
      autocomplete="off"
    >
      <v-container class="py-8">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("supplierData.gestionDatosPers") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.userData") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("supplierData.editUserData2") }}
            </h3>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col cols="12" sm="12" lg="6">
            <label>{{ $t("supplierData.clientCompanyName") }}</label>
            <v-autocomplete
              :color="entityConfig.primaryColor"
              :items="payingCustomer"
              :item-color="entityConfig.primaryColor"
              item-text="name"
              item-value="numClient"
              v-on:change="clientePagador"
              :rule="[rules.required]"
              dense
              outlined
              no-data-text=""
              v-model="name_user"
              @change="changeNameUser(name_user)"
              return-object
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.usernameCompany") }}</label>
            <v-text-field
              dense
              disabled
              v-model="dataUserName"
              v-on:change="changeNombreUsuario"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.nifcif") }}</label>
            <v-text-field
              disabled
              v-model="dataNifCif"
              dense
              v-on:change="changeNif"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.address") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("supplierData.editAddress") }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.address") }}</label>
            <v-text-field
              :rules="[rules.required]"
              dense
              outlined
              v-on:change="changeAddress"
              v-model="address"
              maxlength="50"
              :color="entityConfig.primaryColor"
              hint="50 caracteres"
              counter
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.postalCode") }}</label>
            <v-text-field
              :rules="[rules.required]"
              dense
              outlined
                v-on:change="changePostalCode"
              v-model="postalCode"
              maxlength="5"
              :color="entityConfig.primaryColor"
              hint="5 caracteres"
               counter
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.city") }}</label>
            <v-text-field
              :rules="[rules.required]"
              dense
              outlined
              v-on:change="changeLocation"
              v-model="location"
              hint="50 caracteres"
              maxlength="50"
              counter
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
          <v-col sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.state") }}</label>
            <v-text-field
              :rules="[rules.required]"
              dense
              disabled
              v-on:change="changeProvince"
              v-model="province"
              outlined
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("supplierData.contactData") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("supplierData.editContactData") }}
            </h3>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12" sm="6" md="6" lg="3">
            <label>{{ $t("supplierData.phone") }}</label>
            <v-text-field
              :rules="[rules.maxPhone, rules.ValidatorHasPhone, rules.required]"
              @change="changePhone"
              v-model="phone"
              dense
              outlined
              hint="20 caracteres"
              counter
              maxlength="20"
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="3">
            <label>{{ $t("supplierData.fax") }}</label>
            <v-text-field
              v-on:change="changeFax"
              v-model="fax"
              dense
              outlined
              hint="20 caracteres"
              counter
              maxlength="20"
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="3">
            <label>{{ $t("supplierData.notificationEmail") }}</label>
            <v-text-field
              dense
              hint="50 caracteres"
              counter
              maxlength="50"
              :rules="[rules.email, rules.required]"
              @input="changeEmail"
              v-model="email"
              outlined
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12" sm="12" lg="12">
            <router-link to="/gestion-de-proveedores/confirmar">
              <v-btn
                :disabled="!formIsValid"
                @click="post_data"
                depressed
                :color="entityConfig.primaryColor"
                :style="`color: ${entityConfig.secondaryColor}`"
                class="float-end v-btn-width-default"
                >{{ $t("supplierData.save") }}</v-btn
              >
            </router-link>
          </v-col>
          <v-col></v-col>
        </v-row>
        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-container>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
import passwordValidator from "password-validator";

import { mapMutations } from "vuex";
export default {
  components: { LayoutAuth, Overlay },
  data() {
    return {
      spinner: true,
      payingCustomer: [],
      clients: [],
      formulario: false,
      payingCustomerData: [],
      customerData: [],
      entityConfig: {},

      name_user: "",

      dataUserName: "",
      dataNifCif: "",
      numClient: "",

      address: "",
      postalCode: "",
      province: "",
      phone: "",
      location: "",
      fax: "",
      email: "",

      query: {
        numClient: "",
      },

      rules: {
        maxaddress: (v) => v.length <= 50 || "50 caracteres Maximo",

        nifValidate: (value) => {
          const regex = /([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])/;
          return regex.test(value) || "NIF / NIE / CIF inválido";
        },
        ValidatorHasPhone: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(9);
          return schema.validate(v) || "Debe contener al menos 8 carateres";
        },
        maxPhone: (v) => v.length <= 20 || "20 caracteres Maximo",

        referenceValidatorHasNumber: (v) => {
          var schema = new passwordValidator();
          schema.has().digits(1);
          return schema.validate(v) || "Debe ser numérico";
        },

        max: (v) => v.length <= 9 || "9 caracteres maximo",
        min: (v) => v.length >= 8 || "8 caracteres minimo",
        maxRefenciaProvedor: (v) => v.length <= 10 || "10 caracteres maximo",
        minRefenciaProvedor: (v) => v.length >= 1 || "1 caracteres minimo",

        maxInvoiceAmount: (v) => v.length <= 9 || "9 caracteres maximo",
        maxpostal: (v) => v.length <= 5 || "5 caracteres maximo",

        required: (value) => !!value || "Este campo es requerido..",

        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido.";
        },

        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },
  mounted() {
    this.get_paying_customer_select();
    this.entityConfig = this.$store.state.entityConfig.config;
  },

  computed: {
    formIsValid() {
      return this.formulario;
    },
  },
  methods: {
    post_data() {
      this.$store.commit("management/clientePagador", this.name_user);
      this.$store.commit("management/changeNombreUsuario", this.dataUserName);
      this.$store.commit("management/changeNif", this.dataNifCif);
      this.$store.commit("management/changeAddress", this.address);
      this.$store.commit("management/changePostalCode", this.postalCode);
      this.$store.commit("management/changeProvince", this.province);
      this.$store.commit("management/changePhone", this.phone);
      this.$store.commit("management/changeLocation", this.location);
      this.$store.commit("management/changeFax", this.fax);
      this.$store.commit("management/changeEmail", this.email);
    },

    async changeNameUser(selected) {
      this.query.numCliente = selected.numClient;
      await this.get_list_customer_data();

      this.dataUserName = this.customerData.name;
      this.dataNifCif = this.customerData.supplierId;
      this.address = this.customerData.address;
      this.postalCode = this.customerData.postalCode;
      this.location = this.customerData.location;
      this.province = this.customerData.province;
      this.phone = this.customerData.phone;
      this.fax = this.customerData.fax;
      this.email = this.customerData.email;
    },

    async get_list_customer_data() {
      const qs = Object.keys(this.query)
        .filter(key => this.query[key])
        .map((key) => {
          if (this.query[key])
            return `${encodeURIComponent(key)}=${encodeURIComponent(this.query[key])}`;
        })
        .join("&");
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        this.payingCustomerData = await Api.get(
          `/proveedores/${this.userId}/?${qs}`
        );
        this.customerData = this.payingCustomerData.data.response;

        this.spinner = false;
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },

    async get_paying_customer_select() {
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        this.clients = await Api.get(`/proveedores/${this.userId}/clientes`);
        this.payingCustomer = this.clients.data.response;
        this.spinner = false;
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },

    ...mapMutations("management", [
      "clientePagador",
      "changeNombreUsuario",
      "changeNif",
      "changeAddress",
      "changePostalCode",
      "changeLocation",
      "changeProvince",
      "changePhone",
      "changeFax",
      "changeEmail",
    ]),
  },
};
</script>
